import {Injectable} from '@angular/core';
import {NeoStorageService} from 'ng-neo';
import {NeoTranslationService} from "../neo-translations/neo-translations.service";
import {I18nService} from "../../../shared/i18n";

@Injectable()
export class NeoInitLangService {

    constructor(
        private _storage: NeoStorageService,
        private _translations: NeoTranslationService,
        private _i18n: I18nService,
    ) {
    }

    load(lang = null) {
        return new Promise((resolve) => {
            if (!lang || lang === '') {
                lang = this._storage.getFromLocalStorage('language') || 'es';
            }

            // Obtenemos todas las traducciones del admin
            this._translations.getTranslations('admin').subscribe((translations) => {
                // Guardamos las traducciones
                this._storage.setToSessionStorage("trans", translations);
                this._i18n.setLanguage(lang);
                resolve();
            }, resolve);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-init/neo-init-lang.service.ts